// extracted by mini-css-extract-plugin
export default {"subtitle":"NotificationUsage_subtitle__czdTC","num":"NotificationUsage_num__mw01y","muted":"NotificationUsage_muted__nLWtv"};